import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SectionLabel from "../components/SectionLabel";
import { Button } from "../components/ui/button";
import { getStory } from "../lib/api";

export default function StoryDetail() {
  const { storyId } = useParams();
  const [story, setStory] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getStory(storyId).then(setStory).catch(() => setError(true));
  }, [storyId]);

  if (error) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-4xl text-forest mb-4">Story not found</h1>
      <Link to="/stories" className="text-terracotta link-underline">← Back to all stories</Link>
    </div>
  );

  if (!story) return <div className="py-32 text-center text-ink/50">Loading…</div>;

  return (
    <article className="pt-16 lg:pt-24 pb-32" data-testid="story-detail-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Link to="/stories" className="inline-flex items-center gap-2 text-sm text-ink/70 hover:text-terracotta mb-8 transition-colors" data-testid="story-back-link">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5}/> Back to stories
        </Link>
        <SectionLabel className="mb-5">{story.tag} · {story.date}</SectionLabel>
        <h1 className="font-serif text-4xl lg:text-6xl font-light text-forest leading-tight mb-6">{story.title}</h1>
        <p className="text-ink/70 mb-10">By {story.author}</p>
        <div className="aspect-[16/9] rounded-[2rem] overflow-hidden mb-12">
          <img src={story.image} alt={story.title} className="w-full h-full object-cover"/>
        </div>
        <p className="font-serif text-xl lg:text-2xl text-forest leading-[1.7] dropcap">{story.excerpt}</p>
        <div className="text-lg text-ink/85 leading-[1.8] mt-8 space-y-6">
          <p>{story.body}</p>
        </div>
        <div className="mt-16 pt-12 border-t border-bone-soft text-center space-y-5">
          <h3 className="font-serif text-3xl text-forest">Stories like this need fuel.</h3>
          <p className="text-ink/70">Your donation pays for the trips, the medicines, the late nights.</p>
          <Link to="/donate"><Button className="bg-terracotta hover:bg-terracotta-deep text-bone rounded-full h-12 px-8 font-semibold" data-testid="story-donate-cta">Donate now</Button></Link>
        </div>
      </div>
    </article>
  );
}
